import {combineReducers} from '@reduxjs/toolkit';
import {importAttendeesSlice} from 'src/modules/bulk-update/add-attendees/add-attendees.slice';

import {removeAccountTeamMemberSlice} from './account-team-member/remove-account-team-member';
import {updateAccountTeamMemberSlice} from './account-team-member/update-account-team-member';
import {assignAccountEntitlementsSlice} from './assign-account-entitlements';
import {assignProductAccountEntitlementsSlice} from './assign-product-account-entitlements';
import {assignProductSeatSlice} from './assign-product-seat';
import {assignProductUserEntitlementsSlice} from './assign-product-user-entitlements';
import {assignUserEntitlementsSlice} from './assign-user-entitlements';
import {updateCrmIdsUpdateSlice} from './crm-ids-update/update-crm-ids.slice';
import {importUserSlice} from './import-user';
import {removeAttendeesSlice} from './remove-attendees';
import {sendWelcomeEmailSlice} from './send-welcome-email';
import {unassignAccountEntitlementsSlice} from './unassign-account-entitlements';
import {unassignProductAccountEntitlementsSlice} from './unassign-product-account-entitlements';
import {unassignProductSeatSlice} from './unassign-product-seat';
import {unassignProductUserEntitlementsSlice} from './unassign-product-user-entitlements';
import {unassignUserEntitlementsSlice} from './unassign-user-entitlements';
import {updateAccountStatusSlice} from './update-account-status';
import {assignAccountsEntitlementsSlice, dischargeAccountsEntitlementsSlice} from './update-accounts-entitlements';
import {updateAdminRoleSlice} from './update-admin-role';
import {updateDeviceRegistrationSlice} from './update-device-registration';
import {subscribeToLcdCreditAnalysisSlice, unsubscribeFromLcdCreditAnalysisSlice} from './update-lcd-credit-analysis';
import {licenseAccessModuleDisableResultSlice} from './update-license-access-modules/license-access-module-disable';
import {licenseAccessModuleEnableResultSlice} from './update-license-access-modules/license-access-module-enable';
import {updateMfaSlice} from './update-mfa-settings';
import {updateUserNewsletterSlice} from './update-newsletter';
import {updateUserGroupSlice} from './update-user-group';
import {updateUserStateSlice} from './update-user-state';
import {assignUsersEntitlementsSlice, dischargeUsersEntitlementsSlice} from './update-users-entitlements';
import {updateUserAccountSlice} from './user-change-account';

export const bulkUpdateResultReducer = combineReducers({
    importUserResult: importUserSlice.reducer,
    updateMfaSettingsResult: updateMfaSlice.reducer,
    addAttendeesResult: importAttendeesSlice.reducer,
    updateUserGroupResult: updateUserGroupSlice.reducer,
    updateAdminRoleResult: updateAdminRoleSlice.reducer,
    updateUserStateResult: updateUserStateSlice.reducer,
    crmIdsUpdateResult: updateCrmIdsUpdateSlice.reducer,
    removeAttendeesResult: removeAttendeesSlice.reducer,
    sendWelcomeEmailResult: sendWelcomeEmailSlice.reducer,
    updateUserAccountResult: updateUserAccountSlice.reducer,
    newsletterUpdateResult: updateUserNewsletterSlice.reducer,
    updateAccountStatusResult: updateAccountStatusSlice.reducer,
    accountManagerUpdateResult: updateAccountTeamMemberSlice.reducer,
    assignUserEntitlementsResult: assignUserEntitlementsSlice.reducer,
    assignUsersEntitlementsResult: assignUsersEntitlementsSlice.reducer,
    accountManagerUnassignResult: removeAccountTeamMemberSlice.reducer,
    updateDeviceRegistrationResult: updateDeviceRegistrationSlice.reducer,
    unassignUserEntitlementsResult: unassignUserEntitlementsSlice.reducer,
    dischargeUsersEntitlementsResult: dischargeUsersEntitlementsSlice.reducer,
    assignAccountEntitlementsResult: assignAccountEntitlementsSlice.reducer,
    assignAccountsEntitlementsResult: assignAccountsEntitlementsSlice.reducer,
    unassignAccountEntitlementsResult: unassignAccountEntitlementsSlice.reducer,
    dischargeAccountsEntitlementsResult: dischargeAccountsEntitlementsSlice.reducer,
    licenseAccessModuleEnableResult: licenseAccessModuleEnableResultSlice.reducer,
    licenseAccessModuleDisableResult: licenseAccessModuleDisableResultSlice.reducer,
    subscribeToLcdCreditAnalysisResult: subscribeToLcdCreditAnalysisSlice.reducer,
    unsubscribeFromLcdCreditAnalysisResult: unsubscribeFromLcdCreditAnalysisSlice.reducer,
    assignProductUserEntitlementsResult: assignProductUserEntitlementsSlice.reducer,
    unassignProductUserEntitlementsResult: unassignProductUserEntitlementsSlice.reducer,
    assignProductAccountEntitlementsResult: assignProductAccountEntitlementsSlice.reducer,
    unassignProductAccountEntitlementsResult: unassignProductAccountEntitlementsSlice.reducer,
    assignProductSeatResult: assignProductSeatSlice.reducer,
    unassignProductSeatResult: unassignProductSeatSlice.reducer,
});
